/** Skills, traits, and names — the colonist personality layer. */
import type { SkillKey, NeedKey } from '../types';

export const SKILL_META: Record<SkillKey, { name: string; icon: string }> = {
  growing: { name: 'Growing', icon: '🌱' },
  dealing: { name: 'Dealing', icon: '🤝' },
  combat: { name: 'Combat', icon: '🔫' },
};

export interface Trait {
  id: string;
  name: string;
  blurb: string;
  skill?: Partial<Record<SkillKey, number>>;
  drainMul?: Partial<Record<NeedKey, number>>;
  moodFlat?: number;
  workMul?: number;
  nightWorker?: boolean;
  defenseMul?: number;
}

export const TRAITS: Trait[] = [
  { id: 'green-thumb', name: 'Green Thumb', blurb: '+5 Growing', skill: { growing: 5 } },
  { id: 'smooth', name: 'Smooth Talker', blurb: '+5 Dealing', skill: { dealing: 5 } },
  { id: 'tough', name: 'Tough', blurb: '+4 Combat, sturdier in raids', skill: { combat: 4 }, defenseMul: 1.3 },
  { id: 'hard-worker', name: 'Hard Worker', blurb: '+20% work speed', workMul: 1.2 },
  { id: 'lazy', name: 'Lazy', blurb: '−20% work speed', workMul: 0.8 },
  { id: 'night-owl', name: 'Night Owl', blurb: 'Works fine at night, no mood hit', nightWorker: true },
  { id: 'optimist', name: 'Optimist', blurb: '+6 mood', moodFlat: 6 },
  { id: 'pessimist', name: 'Pessimist', blurb: '−5 mood', moodFlat: -5 },
  { id: 'junkie', name: 'Junkie', blurb: 'Joy drains 40% faster', drainMul: { joy: 1.4 } },
  { id: 'gourmand', name: 'Gourmand', blurb: 'Food drains 35% faster', drainMul: { food: 1.35 } },
  { id: 'insomniac', name: 'Insomniac', blurb: 'Rest drains 25% faster', drainMul: { rest: 1.25 } },
];

export function traitById(id: string): Trait | undefined {
  return TRAITS.find((t) => t.id === id);
}

export const FIRST_NAMES = [
  'Vic', 'Mara', 'Dex', 'Rosa', 'Cole', 'Nadia', 'Sly', 'Jolene', 'Marcus', 'Tasha',
  'Ezra', 'Lena', 'Bishop', 'Cleo', 'Rico', 'Mona', 'Gus', 'Priya', 'Dante', 'Sasha',
  'Otis', 'Wren', 'Hank', 'Imani', 'Lou', 'Greta', 'M050', 'Bo', 'Cassie', 'Theo',
];
export const STREET_NAMES = [
  'Snow', 'Ghost', 'Slim', 'Diesel', 'Pockets', 'Smoke', 'Wheels', 'Sticks', 'Glass', 'Doc',
  'Knuckles', 'Patches', 'Whisper', 'Lucky', 'Fingers', 'Cricket', 'Tonic', 'Halo', 'Switch', 'Birdie',
];

export const SKINS = ['#e8b98a', '#cf9a64', '#9c6a44', '#f0cda0', '#7a5235'];
export const ACCENTS = ['#3fae54', '#9d6bff', '#ff5470', '#4ea8ff', '#ffb454', '#2ed3c6', '#ff79c6'];
